import { useMutation } from '@apollo/client'
import { DeletePrice, DeletePriceVariables } from '../../types'
import { DELETE_COMPANY_PRICE } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useDeleteCompanyPrice = ({ onCompleted }: Props) =>
  useMutation<DeletePrice, DeletePriceVariables>(DELETE_COMPANY_PRICE, {
    onCompleted,
  })
